__turbopack_context__.v({
  "body": "PageBlok-module__WFHdpG__body",
  "root": "PageBlok-module__WFHdpG__root",
});
